import { SeriousAboutTalent } from "@/ui/SeriousAboutTalent";
import { useLocale } from "@/hooks/useLocale";
import { MiniTabs } from "@/ui/MiniTabs";
import { Col } from "react-bootstrap";

export const SpecialismsPageContentSection = ({ className }) => {
  const locale = useLocale();

  return (
    <SeriousAboutTalent
      className={className}
      tag={`page.specialisms.content.tag.${locale}`}
      title={`page.specialisms.content.title.${locale}`}
      text={`page.specialisms.content.text.${locale}`}
      lg={4}
    >
      <Col xs={12} lg={8}>
        <MiniTabs
          className="pt-lg-5 mt-lg-3"
          items={[
            {
              title: { path: `page.specialisms.value.tabs.1.title.${locale}` },
              text: { path: `page.specialisms.value.tabs.1.text.${locale}` },
            },
            {
              title: { path: `page.specialisms.value.tabs.2.title.${locale}` },
              text: { path: `page.specialisms.value.tabs.2.text.${locale}` },
            },
          ]}
          variant="secondary"
        />
      </Col>
    </SeriousAboutTalent>
  );
};

SpecialismsPageContentSection.defaultProps = {
  className: "py-5",
};
